import { venueApi } from '@modules/venue/data'
import { DataHookOptions, useDataList, useDataRead } from '@hooks/data'
import { InventoryItem } from 'types/model'
import { getDateFromNow } from '@utils/date-time'
import { useMemo } from 'react'

function getPath(append?: number | string) {
  return append ? venueApi.pathPrefix.concat(`${append}`) : venueApi.pathPrefix
}

const defaultInventoryListParams = {
  limit: 25,
  skip: 0,
  sort: 'dateStart',
  dateStart: getDateFromNow().toISOString(),
  dateEnd: getDateFromNow({ days: 30 }).toISOString(),
}

export function useInventoryList(
  venue: string | null,
  {
    params = defaultInventoryListParams,
    ...options
  }: DataHookOptions<InventoryItem[]> = {}
) {
  const listOptions = useMemo(
    () => ({
      ...options,
      params: {
        ...defaultInventoryListParams,
        ...params,
      },
    }),
    [options, params]
  )

  const path = venue ? getPath(`/${venue}/inventory`) : null
  return useDataList<InventoryItem>(venueApi, path, listOptions)
}

export function useInventory(
  venue: string | null,
  inventory: string | null,
  options: DataHookOptions<InventoryItem> = {}
) {
  const path =
    venue && inventory ? getPath(`/${venue}/inventory/${inventory}`) : null
  return useDataRead<InventoryItem>(venueApi, path, options)
}
